// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

const RejectReturnApproveButtons = props =>
    <section className='approve-deny-buttons'>
        <a
            className='cancel-button'
            href='#/tcsm/wip'
        >
            <FormattedMessage id='CANCEL'/>
        </a>
        <button onClick={props.onReject}>
            <FormattedMessage id='REJECT'/>
        </button>
        <button onClick={props.onReturn}>
            <FormattedMessage id='RETURN'/>
        </button>
        <button
            className='button-primary'
            onClick={props.onApprove}
        >
            <FormattedMessage id='APPROVE'/>
        </button>
    </section>;

RejectReturnApproveButtons.displayName = 'RejectReturnApproveButtons';
RejectReturnApproveButtons.propTypes = {
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
    onReturn: PropTypes.func.isRequired
};

export default RejectReturnApproveButtons;



// WEBPACK FOOTER //
// ./src/tcsm/spa-details/components/reject-return-approve-buttons.js